import moment from 'moment';

export const formatIclTime = (value?: string) => {
  if (!value) {
    return { date: '', time: '' };
  }

  const [day, month, year, time] = value.split(' ');

  if (!day || !month || !year) {
    return { date: value, time: '' };
  }

  return {
    date: `${day}.${month}.${year.slice(-2)}`,
    time: time || '',
  };
};

export const sortIclsByTime = (icls: any) => {
  return [...icls].sort((a, b) => {
    const dateA = a.time ? moment(a.time, 'DD MM YYYY HH:mm', true).valueOf() : 0;

    const dateB = b.time ? moment(b.time, 'DD MM YYYY HH:mm', true).valueOf() : 0;

    return dateB - dateA;
  });
};
